import { render, staticRenderFns } from "./BaseItems.vue?vue&type=template&id=42b9db6a&"
import script from "./BaseItems.vue?vue&type=script&lang=js&"
export * from "./BaseItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports